import { Card } from "react-bootstrap";
import { useState } from "react";
import { useEffect } from "react";
import Moment from "react-moment";
import { BiCategory } from "react-icons/bi";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import { RxCalendar } from "react-icons/rx";
import { blogPostServices } from "../../../APIServices/SitePilotManagement/BlogManagement/blogPostServices";

const BlogPostPreview = ({ postId }) => {
  const [blogData, setBlogData] = useState("");
  const [loader, setLoader] = useState(false);

  const getPublicSingleBlogPost = async () => {
    setLoader(true)
    let data = await blogPostServices.getPublicSingleBlogPost(postId);
    setBlogData(data?.data || "");
    setLoader(false)
  };

  

  useEffect(() => {
    if (postId) {
      getPublicSingleBlogPost();
    }
  }, [postId]);

  return (
    <Card className="border mb-3">
      <Card.Img
        variant="top"
        style={{ height: 200, objectFit: "cover" }}
        src={"https://i.pravatar.cc/?img=1"}
      />
      <Card.Body>
        <div className="hstack justify-content-between mb-2">
          <div className="hstack gap-2">
            <p style={{ fontSize: 14 }} className="text-muted m-0 hstack gap-1">
              <BiCategory style={{ marginTop: 2 }} /> {blogData?.categoryName}
            </p>
            <p style={{ fontSize: 14 }} className="text-muted m-0 hstack gap-1">
              <MdOutlineArrowRightAlt style={{ marginTop: 2 }} /> {blogData?.subCategoryName}
            </p>
          </div>
          <div className="text-muted hstack gap-2">
            <RxCalendar />
            <Moment format="DD MMM YYYY | HH:mm" withTitle>
              {blogData?.createdAt}
            </Moment>
          </div>
        </div>
        <h4 className="fw-bold ">{blogData?.title}</h4>
        <div dangerouslySetInnerHTML={{ __html: blogData?.longDescription }} />
        {(blogData?.tags || [])?.length > 0 && (
          <div style={{ fontSize: 13 }} className="mt-3">
            {(blogData?.tags || []).map((tag) => (
              <span className="badge bg-primary me-2 mb-2">{tag}</span>
            ))}
          </div>
        )}
        <div className="text-end">
          <p style={{ fontSize: 14 }} className="m-0">
            {blogData?.createdByName} -: Published By
          </p>
          <div className="text-muted">
            <Moment format="DD MMM YYYY | HH:mm" withTitle>
              {blogData?.updatedAt}
            </Moment>
            <span> -: Updated DT</span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BlogPostPreview;
